<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconFecc_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="m19.837 14.824-1.796 1.797-1.414-1.415 1.796-1.797a2 2 0 0 0 0-2.828l-1.796-1.797 1.414-1.415 1.796 1.797a4.001 4.001 0 0 1 0 5.658Zm-9.249-9.252L8.791 7.37 7.377 5.955l1.797-1.797a3.999 3.999 0 0 1 5.656 0l1.797 1.797-1.414 1.414-1.797-1.797a2 2 0 0 0-2.828 0Zm-3.21 3.212L5.962 7.369 4.167 9.166a4.001 4.001 0 0 0 0 5.658l1.796 1.797 1.414-1.414-1.796-1.798a2 2 0 0 1 0-2.828l1.796-1.797Zm9.249 9.251-1.414-1.414-1.797 1.797a2 2 0 0 1-2.828 0L8.791 16.62l-1.414 1.414 1.797 1.797a3.999 3.999 0 0 0 5.656 0l1.797-1.797Zm-4.625-3.212a2.828 2.828 0 1 0 0-5.655 2.828 2.828 0 0 0 0 5.655Z"
        clip-rule="evenodd"
    />
</svg>
